import * as API from "middleware/api";

export const investorTestPre = () => API.executeWithAccessToken("/investmentFunds.investorTest.pre");

export const investorTestSend = (params) =>
    API.executeWithAccessToken("/investmentFunds.investorTest.send", { ...params });

export const investorProfileRead = () => API.executeWithAccessToken("/investmentFunds.investorTest.read");

export const dashboardPre = () => API.executeWithAccessToken("/investmentFunds.dashboard.pre");

export const accountOfficerContact = (params) =>
    API.executeWithAccessToken("/investmentFunds.contact.accountOfficer", { ...params });

export const listAccounts = () => API.executeWithAccessToken("/investmentFunds.myAccounts.list");

export const addAccountSend = (params) => API.executeWithAccessToken("/investmentFunds.addAccount.send", { ...params });

export const downloadAccountTerms = () => API.executeWithAccessToken("/investmentFunds.account.download.ddjj");

export const accountDocumentUpload = (params) =>
    API.executeWithAccessToken("/investmentfunds.addAccount.document.upload", params);

export const accountDocumentDelete = (params) =>
    API.executeWithAccessToken("/investmentfunds.addAccount.document.delete", params);
